import BrowseListCard from './BrowseListCard';

export default BrowseListCard;
